import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowRightIcon from '@wix/da-ds/pkg/Icons/16x16/ArrowRight';
import ResaleIcon from '@wix/da-ds/pkg/Icons/16x16/Resale';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { pushExclusiveTransactionHistoryModal } from '../../../../../../Modals/redux/actionCreators';
import { useBatchedCallback } from '@wix/da-hooks/pkg/useBatchedCallback';
import s from './TradeCount.scss';
const TradeCount = (_param)=>{
    var { deviation, count, withFlames, onClick } = _param, rest = _object_without_properties(_param, [
        "deviation",
        "count",
        "withFlames",
        "onClick"
    ]);
    const { t } = useTranslation();
    const flameCount = Math.min(3, count);
    const dispatchPushExclusiveTransactionHistoryModal = useAction(pushExclusiveTransactionHistoryModal);
    const openTransactionHistoryModal = useCallback(()=>{
        dispatchPushExclusiveTransactionHistoryModal(deviation);
    }, [
        deviation,
        dispatchPushExclusiveTransactionHistoryModal
    ]);
    const handleClick = useBatchedCallback(openTransactionHistoryModal, onClick);
    if (withFlames) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['root']
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['flames']
        }, Array(flameCount).fill(0).map((_, index)=>/*#__PURE__*/ React.createElement("img", {
                key: `flame-${index}`,
                alt: "",
                className: s['flame'],
                src: "https://st.deviantart.net/eclipse/icons/i9.14_tradingflame.gif"
            }))), /*#__PURE__*/ React.createElement(TextButton, _object_spread({
            variant: "main",
            size: "small",
            postfix: ArrowRightIcon,
            onClick: handleClick
        }, rest), t('sidebar.exclusives.tradeCount', {
            count
        })));
    }
    return /*#__PURE__*/ React.createElement(TextButton, _object_spread({
        variant: "main",
        size: "small",
        icon: ResaleIcon,
        postfix: ArrowRightIcon,
        onClick: handleClick
    }, rest), t('sidebar.exclusives.tradeCount', {
        count
    }));
};
TradeCount.displayName = 'TradeCount';
export default TradeCount;

//# sourceMappingURL=TradeCount.js.map